import * as constants from '../constants'

export const accountUpdate = payload => ({ payload, type: constants.ACCOUNT_UPDATE })
export const accountUpdateSubmit = payload => ({ payload, type: constants.ACCOUNT_UPDATE_SUBMIT })
export const accountUpdateFailure = payload => ({ payload, type: constants.ACCOUNT_UPDATE_FAILURE })
